var exports = {
  "x": "x61f99309--86a021--offer",
  "Sl": "x61f99309--86a021--image",
  "Qs": "x61f99309--86a021--content",
  "gL": "x61f99309--86a021--offer-info",
  "Sw": "x61f99309--86a021--no-divide",
  "y$": "x61f99309--86a021--offer--selected",
  "P6": "x61f99309--86a021--offer--disabled",
};

module.exports = exports;
